import { Directive, ElementRef, HostListener, inject, Input } from '@angular/core';

@Directive({
  selector: '[overflowTooltip]',
  exportAs: 'overflow',
  standalone: true
})
export class OverflowTooltipDirective {
  @Input({ required: true }) overflowTooltip: string;

  #element: HTMLElement = inject(ElementRef).nativeElement;

  tooltip = '';

  @HostListener('mouseover')
  onMouseEnter(): void {
    this.tooltip = this.isOverflow() ? this.overflowTooltip : '';
  }

  isOverflow(): boolean {
    return this.#element.scrollWidth > this.#element.offsetWidth;
  }
}
